
import { WizCommand } from '@wizeoo/akm-component-lib';
import { WIZ_COMMAND_METHOD} from '@wizeoo/akm-core-lib';
import { BasicScenario, MeasureCriteria, MeasureWrapper } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/**
 * Commande REST de recherche des measures
 */
export class FindMeasureCommand extends WizCommand<MeasureWrapper> {

    
    protected model: Model = null;

    constructor(model: Model) {
      super();
      this.model = model;
      const wrapper: MeasureWrapper = new MeasureWrapper();
      wrapper.method = WIZ_COMMAND_METHOD.FIND;
      wrapper.scenario = new BasicScenario();
      wrapper.scenario.languageCode = this.model.currentLocaleCode;
      wrapper.criteria = new MeasureCriteria();
      wrapper.criteria.domain = this.model.domainCode;
      wrapper.criteria.businessUnitCode = this.model.businessUnitCode;
      this.configureRemote(ExternalAPI.MEASURE_API, wrapper);
    }

    wizResult() {
        super.wizResult();
        if (!!this.result) {
          this.model.measureEngine.feedMeasures(this.result.entities);
        }
    }
  
}
